module.exports = __webpack_public_path__ + "static/media/exakt.22961ff9.mp3";